const stateKey = 'app-state';
const localStoreRedux = {
	loadState: () => {
		try {
			const serializedState = localStorage.getItem(stateKey);
			if (serializedState === null) {
				return undefined;
			}

			return JSON.parse(serializedState);
		}
		catch (err) {
			return undefined;
		}
	},
	saveState: (state: any) => {
		try {
			const serializedState = JSON.stringify(state);
			localStorage.setItem(stateKey, serializedState);
		} catch (err) {
			// tslint:disable-next-line
			console.error('failed to write redux state to local storage', err);
		}
	}
};

export default localStoreRedux;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/localStoreRedux.ts